import { css } from '@emotion/react';
import { colors } from '../../../theme/colors';

export const sectionCss = css`
  flex: 1;
  min-width: 0;
`;

export const sectionTitleCss = css`
  font-size: 12px;
  line-height: 1.66;
  color: ${colors.text.secondary};
`;

export const detailRowCss = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: ${colors.text.main};
`;

export const detailLabelCss = css`
  font-size: 12px;
  line-height: 16px;
  width: 120px;
  flex-shrink: 0;
`;

export const detailValueCss = css`
  font-size: 12px;
  line-height: 1.66;
  flex: 1;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const detailLinkCss = css`
  font-size: 12px;
  line-height: 1.66;
  flex: 1;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  color: ${colors.primary[60]};
`;

export const pinnedAccentBarCss = css`
  height: 100%;
  background: white;
  border-bottom: 0.5px solid ${colors.neutral[20]};
  border-left: 0.5px solid ${colors.neutral[20]};
  box-shadow: inset 3px 0 0 ${colors.primary[60]};
`;

export const panelContainerCss = css`
  display: flex;
  background: white;
  border-bottom: 0.5px solid ${colors.neutral[20]};
  border-right: 0.5px solid ${colors.neutral[20]};
  border-left: 0.5px solid ${colors.neutral[20]};
  box-shadow: inset 3px 0 0 ${colors.primary[60]};
`;

export const panelContentCss = css`
  display: flex;
  flex: 1;
  gap: 8px;
  padding: 8px 12px 12px;
  min-width: 0;
`;

export const verticalDividerCss = css`
  width: 1px;
  flex-shrink: 0;
  background: ${colors.neutral[20]};
  align-self: stretch;
`;
